import React from "react";

const Gründung = () => {
  return (
    <section className="col col-md-9 col-lg-8 mx-auto rounded-2 my-md-3 shadow-lg">
      <div className="col col-md-12 p-3 z-1">
        <p className="mx-auto responsive-fs lh-base text-center py-3 link-offset-3-hover">
          Das Harmonie e.V. Wurde 2023 von engagierten ehrenamtlichen
          Bildungsmitarbeitern gegründet. Der Verein hat sich zunächst auf
          Angebote entsprechend den Interessen und Bedürfnissen der eigenen
          Mitglieder und deren Kinder konzentriert.
        </p>
      </div>
    </section>
  );
};

export default Gründung;
